import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2, Mail, Phone, Calendar, Car } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminSignups = () => {
  const [signups, setSignups] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSignups = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_URL}/api/rally-signups`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSignups(response.data);
    } catch (error) {
      toast.error('Failed to fetch signups');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSignups();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this signup?')) return;
    
    const token = localStorage.getItem('token');
    try {
      await axios.delete(`${API_URL}/api/rally-signups/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Signup deleted');
      fetchSignups();
    } catch (error) {
      toast.error('Failed to delete signup');
    }
  };

  return (
    <div data-testid="admin-signups">
      <h1 className="font-['Oswald'] text-3xl text-[#F2EDE6] mb-8">RALLY SIGNUPS</h1>

      {loading ? (
        <p className="text-[#A19D98]">Loading...</p>
      ) : signups.length === 0 ? (
        <p className="text-[#A19D98]">No signups yet.</p>
      ) : (
        <div className="grid gap-4">
          {signups.map((signup) => (
            <div
              key={signup.id}
              data-testid={`signup-card-${signup.id}`}
              className="bg-[#141414] border border-[#2A2A2A] p-6"
            >
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="font-['Oswald'] text-xl text-[#F2EDE6]">{signup.full_name}</h3>
                  <p className="text-[#E8651A] text-sm">{signup.rally_name || 'Unknown Rally'}</p>
                </div>
                <button
                  onClick={() => handleDelete(signup.id)}
                  className="p-2 text-[#A19D98] hover:text-[#FF3B30]"
                >
                  <Trash2 size={18} />
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <div className="flex items-center gap-2 text-[#A19D98]">
                  <Mail size={14} />
                  <a href={`mailto:${signup.email}`} className="hover:text-[#E8651A]">
                    {signup.email}
                  </a>
                </div>
                <div className="flex items-center gap-2 text-[#A19D98]">
                  <Phone size={14} />
                  <a href={`tel:${signup.phone}`} className="hover:text-[#E8651A]">
                    {signup.phone}
                  </a>
                </div>
                <div className="flex items-center gap-2 text-[#A19D98]">
                  <Car size={14} />
                  <span>{signup.car_year} {signup.car_make} {signup.car_model}</span>
                </div>
                <div className="flex items-center gap-2 text-[#A19D98]">
                  <Calendar size={14} />
                  <span>{new Date(signup.created_at).toLocaleDateString()}</span>
                </div>
                {signup.user_id && (
                  <div className="flex items-center gap-2 text-[#34C759] text-xs">
                    ✓ Member account
                  </div>
                )}
              </div>

              {signup.instagram_handle && (
                <p className="text-[#A19D98] text-sm mt-2">
                  Instagram: {signup.instagram_handle}
                </p>
              )}

              {signup.message && (
                <div className="mt-4 pt-4 border-t border-[#2A2A2A]">
                  <p className="text-[#A19D98] text-sm">{signup.message}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminSignups;
